import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "m-auto flex max-w-4xl flex-col p-1 sm:px-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 h-60 w-full border-t border-solid border-gray-500" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.mapTypeComponents[item.type]), _mergeProps({ key: index }, item), null, 16))
    }), 128)),
    _hoisted_2
  ]))
}